import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './BusinessChallenges.css';
import Footer from '../page-layout/footer/Footer';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import moment from "moment";
import { Container, Row, Col, Modal, Form, Card, Button, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { GetBusinessChallenges } from '../../utils/axios/ChallengesAPI';
import { GetLookUps, GetSelectedBranches } from '../../utils/axios/LookUpAPI';
import { GrokLoading } from "../page-layout/loading/Loading";
import { GetColleges } from '../../utils/axios/CompanyAPI';
import { RegisterAndSubmitChallenge } from '../../utils/axios/MyChallengesAPI';
import { ConfirmAlert, TimerAlert, InforAlert } from '../../utils/swtAlert';
import { CreateEnrollUser, uploadPdf } from '../../utils/axios/EnrollUserAPI';
import { RankWinners } from '../../utils/axios/ChallengeWinnerAPI';
import useLocalStorage from "use-local-storage";


const BusinessChallenges = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [data, setData] = useState([]);
    const [isConditionsAccepted, setIsConditionsAccepted] = useState(false);
    const [isConditions2Accepted, setIsConditions2Accepted] = useState(false);
    const [loading, setLoading] = useState(true);
    const [validated, setValidated] = useState(false);

    //Form Control Variables Starts..
    const [registrationDate, setRegistrationDate] = useState('');
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [displayName, setDisplayName] = useState("");
    const [college, setCollege] = useState("");
    const [collegeslist, setCollegesList] = useState([]);
    const [branch, setBranch] = useState("");
    const [branchlist, setBranchlist] = useState([]);
    const [year, setYear] = useState("");
    const [yearlist, setYearlist] = useState([]);
    const [semester, setSemester] = useState("");
    const [semesterlist, setSemesterlist] = useState([]);
    const [Gender, setGender] = useState("");
    const [allowdetails, setAllowDetails] = useState(false);
    const [challengeTitle, setChallengeTitle] = useState('');
    const [challengename, setChallengeName] = useState([]);
    const [branchlists, setBranchlists] = useState([]);
    const [orgnames, setOrgNames] = useState([]);
    const [closingdate, setClosingDate] = useState([]);
    const [CreateRegister, setCreateRegister] = useState(false);
    const [Course, setCourse] = useState([]);
    const [ContactNumber, setContactNumber] = useState("");
    const [email, setEmail] = useState("");
    const [genterlist, setGenderList] = useState([]);
    const [courseList, setCourseList] = useState([]);
    const [NumberError, setNumberError] = useState('');
    const [RegistrationNumber, setRegistrationNumber] = useState('');
    const [isOthersSelected, setIsOthersSelected] = useState(false);
    const [newCollege, setNewCollege] = useState("");

    //enroll states 
    const [Enrollcollege, setEnrollCollege] = useState("");
    const [pdfUpload, setPDFUpload] = useState([]);
    const [Enrollbranch, setEnrollBranch] = useState("");
    //Form Control Variables End..
    const [animationClass, setAnimationClass] = useState('');
    const [animationClass1, setAnimationClass1] = useState('');
    const defaultDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    const [theme, setTheme] = useLocalStorage(
        "theme",
        defaultDark ? "dark" : "light"
    );

    const switchTheme = () => {
        const newTheme = theme === "light" ? "light" : "";
        // const newTheme = localStorage.getItem("theme");
        setTheme(newTheme);
        document.body.setAttribute("data-theme", newTheme);
    };

    const [selectedChallengId, setSelectedChallengeId] = useState('');
    const getHomeChallenges = async () => {
        setLoading(true);
        var challengesResponse = await GetBusinessChallenges();
        setData(challengesResponse.data);
        setLoading(false);
    }

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = (title, description) => {
        setShow(true);

        setTimeout(() => {
            document.getElementById('Title').innerText = title;
            document.getElementById('Description').innerText = description
        }, 10);
    }

    const [registerShow, setRegisterShow] = useState(false);
    const handleRegisterClose = () => {
        setRegisterShow(false);
        setIsConditionsAccepted(false);
        setIsOthersSelected(false);
        setFirstName('');
        setLastName('');
        setCollege('');
        setBranch('');
        setYear('');
        setSemester('');
        setEmail('');
        setValidated(false);
        setContactNumber('');
        setNumberError('');
        setGender('');
        setNewCollege('');
        setEnrollCollege('');
    };
    const handleRegisterShow = (id, challengeTitle, orgName, endDate) => {
        bindFormPreloadData();
        setRegisterShow(true);
        setSelectedChallengeId(id);
        setClosingDate(endDate);
        setOrgNames(orgName);
        setChallengeName(challengeTitle);
        setTimeout(() => {
            document.getElementById('ChallengeTitle').innerText = challengeTitle;
            document.getElementById('OrganizationId').innerText = orgName;
            document.getElementById('ClosingDate').innerText = endDate
        }, 10);
    };

    const handleEnroll = () => {
        setCreateRegister(true);
        setAllowDetails(false);
        bindFormPreloadData();
    }

    const handleWinnerView = () => {
        navigate('/winnerslist')
    }

    const handleSubmiting = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
        }
        else {
            // InforAlert("Registered Successfully", 'Grok Team will email soon', 'success', 'OK')
            // handleRegisterClose();
            createEnroll();
        }
    }

    const downloadPDF = async () => {
        const pdfUrl = require('../../images/college_letter.pdf');
        const fileName = pdfUrl.split('/').pop();
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = 'college_letter.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        console.log('PDF downloaded successfully.');
    };

    const createEnroll = async () => {
        setLoading(true);
        let registrationPayload = {
            OrganizationId: null,
            ChallengeId: selectedChallengId,
            RegistrationDate: registrationDate,
            OrganizationName: Enrollcollege,
            FirstName: firstName,
            LastName: lastName,
            Gender: Gender,
            Branch: branch,
            Year: year,
            Semester: semester,
            Email: email,
            ContactNumber: ContactNumber,
            ApprovalLetterPdf: pdfUpload.name,
        }
        var EnrollUserResponse = await CreateEnrollUser(registrationPayload);
        if (EnrollUserResponse) {
            // if(EnrollUserResponse.status === 200){
            if (EnrollUserResponse?.uploadUrl) {
                await uploadPdf(EnrollUserResponse.uploadUrl, pdfUpload);
                InforAlert('Thanks for registration. Your Registration is under veryfication. login credentials will be mailed to you once Approved ', "Pending Approval", 'success', 'OK')
                    .then((result) => {
                        if (result.isConfirmed) {
                            handleRegisterClose();
                            setCreateRegister(false);
                        }
                    })
                setLoading(false);
            }
            // }
            else if (EnrollUserResponse.response?.data.message === "Email already in use, wait for Grok Admin Approval") {
                InforAlert("Registration failed", 'Email already in use. Please wait for Grok Admin approval.', 'warning', 'OK');
            }
            else if (EnrollUserResponse.response?.data.message === "This Email already registered and approved please login") {
                InforAlert("Please Login", 'Email already Registered and Approved.', 'warning', 'OK');
            }
            else if (EnrollUserResponse.response?.data.message === "Email is already registered") {
                InforAlert("Registration failed", 'Email already in use. Please contact GROK Admin.', 'warning', 'OK');
            }
            else if (EnrollUserResponse.message === "Request failed with status code 500") {
                InforAlert("Registration failed", 'There is an issue with the server. Please try again later.', 'warning', 'OK');
            }
        }

        setLoading(false);
    }

    const handleTermsandConditions = () => {
        var terms = document.getElementById('terms');
        if (terms.checked == true) {
            setIsConditionsAccepted(true);
        }
        else {
            setIsConditionsAccepted(false);
        }
    }

    const columns = [
        {
            name: "Register",
            width: "170px",
            cell: (row) => (<>
                <button className="btn registerBtn" title="Register" onClick={() => handleRegisterShow(row._id, row.Title, row.OrganizationId.name, moment(row.ClosingDate).format("DD/MM/YYYY"))} >New</button>
                <button className="btn registerBtn" title="Register" onClick={() => loginBtn()} style={{ marginLeft: "5px" }} >Existing</button>
            </>),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
        {
            name: "Industry Use Case",
            selector: row => row.Title,
            sortable: true,
            cell: row => row.Title,
        },
        {
            name: "Industry Partner",
            selector: row => row.OrganizationId.name,
            sortable: true,
            cell: row => row.OrganizationId.name,
        },
        {
            name: "Posting Date",
            width: "180px",
            selector: row => moment(row.CreatedDate).format("DD/MM/YYYY"),
            sortable: true,
            cell: row => moment(row.CreatedDate).format("DD/MM/YYYY")
        },
        {
            name: "Closing Date",
            width: "180px",
            selector: row => moment(row.ClosingDate).format("DD/MM/YYYY"),
            sortable: true,
            cell: row => moment(row.ClosingDate).format("DD/MM/YYYY")
        },
        {
            name: "Description",
            width: "150px",
            cell: (row) => (<>
                <button className="btn btn-link" title="Description" onClick={() => handleShow(row.Title, row.ChallengeBrief)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"></path></svg></span></button>
            </>),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        }
    ];

    const tableData = {
        columns,
        data,
        print: false,
        export: false
    };

    const loginBtn = () => {
        navigate('/login');
    }

    const EnrollNow = async  () => {
        navigate('/enrollmentMenu');
    }
    const handleCreateuser = () => {
        setCreateRegister(true);
        setRegisterShow(false);
        setAllowDetails(true);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
        }
        else {
            if (college === "others") {
                createEnroll();
                console.log("tempuser");
            }
            else {
                saveRegistration();
                console.log("studentchallenge");
                setEnrollCollege('');
            }
        }
    }

    const bindFormPreloadData = async () => {
        setLoading(true);
        //Getting Semester List from Lookup
        let semesterpayload = {
            Type: 6
        }
        var semesterResponse = await GetLookUps(semesterpayload);
        setSemesterlist(semesterResponse.data);

        //Getting Year List from Lookup
        let yearpayload = {
            Type: 2
        }
        var yearResponse = await GetLookUps(yearpayload);
        setYearlist(yearResponse.data);

        //Getting Branch List from Lookup
        let branchPayload = {
            Type: 7
        }
        var branchResponse = await GetLookUps(branchPayload);
        setBranchlists(branchResponse.data);


        var clgResponse = await GetColleges();
        setCollegesList(clgResponse.data);
        setLoading(false);

        let genderpayload = {
            Type: 1
        }
        var genderResponse = await GetLookUps(genderpayload);
        setGenderList(genderResponse.data);

        let coursepayload = {
            Type: 4
        }
        var courseResponse = await GetLookUps(coursepayload);
        setCourseList(courseResponse.data)

    }
    const handlphnumberchange = (e) => {
        setContactNumber(e);
        const securePhoneNumberRegex = /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4,})$/;
        if (!securePhoneNumberRegex.test(e)) {
            setNumberError("Please enter a valid phone number.");
        }
        else {
            setNumberError('');
        }

    };

    const copyPassword = () => {
        getSelection().removeAllRanges();
        var range = document.createRange();
        range.selectNodeContents(document.getElementById("pwd"));
        getSelection().addRange(range);
        document.execCommand("copy");
    }

    const collegeChanged = async (e) => {
        const selectedCollege = e.target.value;
        setCollege(selectedCollege);
        setIsOthersSelected(selectedCollege === "others")
        if (selectedCollege !== "" && selectedCollege !== "others") {
            let branchesPayload = {
                OrganizationId: e.target.value
            }
            setLoading(true);
            var response = await GetSelectedBranches(branchesPayload);
            setBranchlists(response.data);
            setLoading(false);
        }
        else if (selectedCollege === "others") {
            let branchPayload = {
                Type: 7
            }
            var branchResponse = await GetLookUps(branchPayload);
            setBranchlists(branchResponse.data);
        }
        setBranch("");
        setYear("");
        setSemester("");
        setEnrollCollege('');
    };

    const saveRegistration = async () => {
        let registrationPayload = {
            OrganizationId: college,
            ChallengeId: selectedChallengId,
            FirstName: firstName,
            LastName: lastName,
            Gender: Gender,
            Branch: branch,
            Year: year,
            Semester: semester,
            MobileNumber: ContactNumber,
            Email: email,
        }
        var registerResponse = await RegisterAndSubmitChallenge(registrationPayload);
        if (registerResponse.success && (registerResponse.RandomPassword !== "")) {
            ConfirmAlert("Registered Successfully", `Your Credentials <p id='pwd' class="copyPassword">${registerResponse.RandomPassword}</p>`, 'success', '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><rect width="336" height="336" x="128" y="128" fill="none" stroke-linejoin="round" stroke-width="32" rx="57" ry="57"></rect><path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M383.5 128l.5-24a56.16 56.16 0 00-56-56H112a64.19 64.19 0 00-64 64v216a56.16 56.16 0 0056 56h24"></path></svg> Copy Password')
                .then((result) => {
                    if (result.value) {
                        copyPassword();
                        handleRegisterClose();
                    }
                    // else if (!result.value) {
                    // }
                });
        }
        else if (registerResponse.response?.data === "You have already used this challenge.") {
            InforAlert("Already Registered!", 'You have already registered this challenge', 'warning', 'OK')
                .then((result) => {
                    if (result.isConfirmed) {
                        handleRegisterClose();
                    }
                });
        }
        else if (registerResponse.response?.data.message === "Email already registered with another Organization") {
            InforAlert("Please Login!", 'You have already registered this Email with another Organization', 'warning', 'OK')
                .then((result) => {
                    if (result.isConfirmed) {
                        handleRegisterClose();
                    }
                });
        }
        else if (registerResponse.response?.data === "Student not found.") {
            ConfirmAlert('Please contact our GROK team', "You haven't registered in our platform , If You wants to register please Enroll Now!!!", 'warning', 'Enroll Now')
                .then((result) => {
                    if (result.isConfirmed) {
                        handleCreateuser();
                    }
                });
        }
        else if (registerResponse.success && (registerResponse.RandomPassword === "")) {
            InforAlert("Registered Successfully", 'Now you can login with your username and password', 'success', 'OK')
                .then((result) => {
                    if (result.isConfirmed) {
                        handleRegisterClose();
                    }
                });
        }
    }
    const [winnercount, setWinnercount] = useState('');
    const [winnersdetail, setwinnersdetail] = useState([]);
    const [seeMore, setSeeMore] = useState(false);
    const getRankwinners = async () => {
        let payload = {
            isWinner: true
        }
        var winnerResponse = await RankWinners(payload);
        setwinnersdetail(winnerResponse.data);
    }
    const getRankwinnerscount = async () => {
        var winnerResponse = await RankWinners();
        if (winnerResponse.count > 3) {
            setSeeMore(true)
        }
    }

    // Register component to move
    const handleRegister = () => {
        const registerPage = document.getElementById('register_page');
        if (registerPage) {
            registerPage.scrollIntoView({ behavior: 'smooth' });
        }
    };

    useEffect(() => {
        localStorage.setItem('theme', 'light');
        getHomeChallenges();
        getRankwinners();
        getRankwinnerscount();
        switchTheme();
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split('T')[0];
        setRegistrationDate(formattedDate);
        // setAnimationClass('slide-in-left');
        // setAnimationClass1('slide-in-right');
    }, [location]);

    return (
        <div className='page'>
            {loading ? <GrokLoading /> : ""}

            <div className='page-wrapper'>
                <div>
                    <Navbar expand="lg" className="bg-body-tertiary bg-color">
                        <Container fluid className='d-flex justify-content-between align-items-center flex-grow-1 header-color'>
                            <Navbar.Brand>
                                <div className='light-logo'>
                                    <span className="navbar-brand">
                                        <img src={require("../../images/grok pvt ltd logo.png")} className="img-fluid navbar_logo" width={90} height={80} alt="patient-card" />
                                    </span>
                                </div>
                                <div className='dark-logo'>
                                    <span className="navbar-brand">
                                        <img src={require("../../images/grok pvt ltd logo_dark.png")} className="img-fluid navbar_logo" width={90} height={80} alt="patient-card" />
                                    </span>
                                </div>
                            </Navbar.Brand>
                            <div className='text-center flex-grow-1'>
                                <h4 className='landing_head'>Grok Industry Academia Collaboration</h4>
                            </div>
                            <Navbar.Toggle aria-controls="navbarScroll" />
                            <Navbar.Collapse id="navbarScroll">
                                <Nav className="ms-auto my-2 my-lg-0 demo_nav" navbarScroll >
                                </Nav>
                                <Form className="d-flex">
                                    <button className='loginBtn_style m-2' type='submit' onClick={() => EnrollNow()}>
                                        <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                            <circle cx="8.5" cy="7" r="4" />
                                            <line x1="20" y1="8" x2="20" y2="14" />
                                            <line x1="23" y1="11" x2="17" y2="11" />
                                        </svg>
                                        </span>&nbsp;&nbsp;
                                        Enroll as Partner Now!
                                    </button>
                                </Form>
                                <Form className="d-flex">
                                    <button className='loginBtn_style m-2' type='submit' onClick={() => loginBtn()}>
                                        <span><svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line></svg></span>&nbsp;&nbsp;
                                        Login
                                    </button>
                                </Form>
                            </Navbar.Collapse>
                        </Container>
                    </Navbar>
                </div>
                <Container fluid>
                    <div className='winner_position my-1 business_tbl'>
                        <div>
                            <h4 className='d-flex justify-content-center my-2 land_subhead'>Facilitating collaboration between Industry & Educational Institutes</h4>
                        </div>
                        <Row className='d-flex align-items-center justify-content-center px-2'>
                            <Col xs={12} md={8} lg={8} className="mb-2">
                                <Row className='d-flex flex-col'>
                                    <h5 className='text-bold my-2 landing_subtitle1'>How Collaboration between Industry & Educational Institutes Will Benefit Students?</h5>
                                    <Col xs={12} md={12} lg={12} className="landing_para">
                                        <b >• Access to Problem Statements of Different Industries</b>
                                    </Col>
                                    <Col xs={12} md={12} lg={12} className="landing_para text-indent">
                                        Students using our Applied Learning & Skilling Platform will get to work on real industrial problem statements shared directly by various companies. By building solutions for these use-cases, they will get exposure to how industries work, honing their problem-solving abilities and creative thinking skills in the process.
                                    </Col>
                                    <Col xs={12} md={12} lg={12} className="landing_para">
                                        <b>• Platform to Showcase Hands-on Skills to Companies</b>
                                    </Col>
                                    <Col xs={12} md={12} lg={12} className="landing_para text-indent">
                                        Students will be able to showcase their hands-on skills by presenting innovative solutions using IoT, Cloud Computing, Robotics, and AI. Working hands-on not only reinforces students’ learning but also helps them build their portfolio, positioning them favourably in the eyes of prospective employers
                                    </Col>
                                    <Col xs={12} md={12} lg={12} className="landing_para">
                                        <b>• Opportunity to Apply for Internships or Job Vacancies</b>
                                    </Col>
                                    <Col xs={12} md={12} lg={12} className="landing_para text-indent">
                                        Industries will have access to the work done by the students. Through this process, students can get internships and future jobs according to their hands-on skills
                                    </Col>
                                    <h5 className='text-bold mt-1 landing_subtitle'>Eligibility Criteria</h5>
                                    <Col xs={12} md={12} lg={12} className="landing_para text-indent">
                                        Students currently enrolled in Diploma/Degree programs across all branches of engineering, as well as those pursuing BSc, MSc, and MCA courses are welcome to participate
                                    </Col>
                                    <h5 className='text-bold landing_subtitle'>How to Register?</h5>
                                    <Col xs={12} md={12} lg={12} className="landing_para">
                                        <div className='card-header'>
                                            <Row className="row justify-content-between align-items-center flex-grow-1 ms-2">
                                                <Col className='col-md md-mb-0'>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="mb-0"><b>•</b> Don't have a GROVATOR® Innovation Lab set up by Grok at your college? No worries! You can still register for an industry use case challenge, and we'll grant you access to our platform</div>
                                                    </div>
                                                    <div>Here's what you need to do:</div>
                                                    <div>Obtain a letter from your college on official letterhead, signed and stamped by your Head of Department (HoD) and Principal as per the format provided below</div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                    <Col xs={12} md={12} lg={12} className="landing_para">
                                        <div className='card-header'>
                                            <Row className="row justify-content-between align-items-center flex-grow-1 ms-2">
                                                <Col className='col-md md-mb-0'>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="mb-0">With a scanned copy of the letter, you're all set to enrol for a use case challenge of your choice</div>
                                                    </div>
                                                </Col>
                                                <Col className='col-12 col-md-auto ms-auto d-print-none'>
                                                    <button className='land_btn my-2' onClick={downloadPDF} > Download Format </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                    <h5 className='text-bold landing_subtitle'>Wish You All the Best... Keep Innovating!</h5>
                                </Row>
                            </Col>
                            <Col xs={12} md={4} lg={4} className="my-2">
                                <img className="img-w-h img-fluid landing_img" src={require("../../images/Land_Page-1.png")} />
                            </Col>
                        </Row>
                    </div>

                    <div className='winner_position'>
                        <Row className='d-flex mt-2 latest'>
                            <Col lg={4}></Col>
                            <Col lg={6}>
                                <h4 className='land_subhead' lg={4} >Latest Winners of Industry Use Case Challenge</h4>
                            </Col>
                            {
                                seeMore ?
                                    <Col lg={2} className='d-flex justify-content-end'>
                                        <button className="viewmore_btn" type="button" size="sm" onClick={() => handleWinnerView()} >
                                            see more &nbsp;
                                            <svg stroke="currentColor" className="mb-1" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinejoin="round" strokeWidth="32" d="M448 256 272 88v96C103.57 184 64 304.77 64 424c48.61-62.24 91.6-96 208-96v96z"></path></svg>
                                        </button>
                                    </Col> : ""
                            }
                        </Row>
                        {
                            winnercount === 0 ? <span className='d-flex justify-content-center my-4 tableheader2'>There are No Winners</span> :
                                <Row className='d-flex align-items-center justify-content-center p-2 ms-2'>
                                    {winnersdetail && winnersdetail?.map((item, index) =>
                                        <Col xs={12} md={4} lg={4} className="" >
                                            <div className="">
                                                <Card className={`infocardContainer ${animationClass} my-2 border-0`}>
                                                    <div id="main">
                                                        <img className="img-w-h img-fluid" src={require("../../images/medal1.jpg")} />
                                                    </div>
                                                    <div id="textbois">
                                                        <h3 className='winnername'>Congratulations, {item?.student?.name}</h3>
                                                        <div className="winnername2">Winner of the industry use case challenge <br /> {item?.challenge?.name} organized by</div>
                                                        <div className="winnername1">{item?.challenge?.companyName}</div>
                                                    </div>
                                                </Card>
                                            </div>
                                        </Col>
                                    )}
                                </Row>}
                    </div>
                    <div>
                        <div id='register_page'>
                            <div className='taablist business_tbl'>
                                <div><h4 className='d-flex justify-content-center mt-3 tableheader2' lg={4} >Industry Use Case </h4></div>
                                <DataTableExtensions {...tableData}>
                                    <DataTable
                                        columns={columns}
                                        data={data}
                                        fixedHeader
                                        defaultSortField="id"
                                        defaultSortAsc={false}
                                        pagination
                                        paginationPerPage={10}
                                        paginationRowsPerPageOptions={[10, 20, 30, 50]}
                                        rowCount={25}
                                        rowsPerPage={10}
                                        highlightOnHover
                                        className='home_table'
                                    />
                                </DataTableExtensions>
                            </div>
                        </div>

                        <div>
                            <Modal show={show} onHide={handleClose} size="lg" backdrop="static" keyboard={false} className="model-popup" aria-labelledby="contained-modal-title-vcenter" centered>
                                <Modal.Header closeButton>
                                    <Modal.Title><b>Industry Use Cases Description</b> </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div>
                                        <Row className="align-items-center">
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>
                                                        <div id='Title'></div>
                                                    </Form.Label>
                                                    <div className="col">
                                                        <div className='small' id='Description'></div>
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>
                                </Modal.Body>
                            </Modal>
                        </div>

                        <div>
                            <Modal show={registerShow} onHide={handleRegisterClose} size="xl" backdrop="static" keyboard={false} className="model-popup" aria-labelledby="contained-modal-title-vcenter" centered>
                                {loading ? <GrokLoading /> : ""}
                                <Modal.Header closeButton>
                                    <Modal.Title><b>Participant Registration</b> </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className='challenge_detail_style mb-3'>
                                        <div id='ChallengeTitle' className='mx-2'></div>&#47;
                                        <div id='OrganizationId' className='mx-2'></div>&#47;
                                        <div id='ClosingDate' className='ms-2'></div>
                                    </div>
                                    <div>
                                        <Form autoComplete="off" noValidate validated={validated} onSubmit={handleSubmit}>
                                            <Row className="align-items-center">
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label> Registration Date <em className="Required">*</em></Form.Label>
                                                        <div className="col">
                                                            <Form.Control type="Date" className='readOnly' id="RegistrationDate" value={registrationDate} required readOnly />
                                                            <Form.Control.Feedback type="invalid">Invalid Registration Date </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label >First Name <em className="Required">*</em> </Form.Label>
                                                        <div className='col'>
                                                            <Form.Control type="text" id="FirstName" value={firstName} onChange={(e) => setFirstName(e.target.value)} minLength={3} placeholder="Enter First Name" required />
                                                            <Form.Control.Feedback type="invalid">Invalid FirstName </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label >Last Name <em className="Required">*</em> </Form.Label>
                                                        <div className='col'>
                                                            <Form.Control type="text" id="LastName" value={lastName} onChange={(e) => setLastName(e.target.value)} minLength={1} placeholder="Enter Last Name" required />
                                                            <Form.Control.Feedback type="invalid">Invalid LastName </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label >Display Name </Form.Label>
                                                        <div className='col'>
                                                            <Form.Control type="text" className='displayname' id="Name" value={firstName + " " + lastName} onChange={(e) => setDisplayName(e.target.value)} readOnly />
                                                            <Form.Control.Feedback type="invalid">Invalid DisplayName </Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col><Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Gender<em className="Required">*</em></Form.Label>
                                                        <div className="col">
                                                            <Form.Select as="select" value={Gender} onChange={(e) => setGender(e.target.value)} required >
                                                                <option value={""}>Select</option>
                                                                {genterlist.map(item => (
                                                                    <option key={item._id} value={item._id}>{item.Name}</option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">Gender is required</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Associate College<em className="Required">*</em></Form.Label>
                                                        <div className="col">
                                                            <Form.Select as="select" value={college} onChange={collegeChanged} required >
                                                                <option value={""}>Select</option>
                                                                <option value={"others"}>Others</option>
                                                                {collegeslist.map(item => (
                                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                                ))}

                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid"> Associate CollegeName is required</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                {
                                                    isOthersSelected ?
                                                        <>
                                                            <Col lg={4}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label >College Name <em className="Required">*</em> </Form.Label>
                                                                    <div className='col'>
                                                                        <Form.Control type="text" id="FirstName" value={Enrollcollege} onChange={(e) => setEnrollCollege(e.target.value)} minLength={3} placeholder="Enter College Name" required />
                                                                        <Form.Control.Feedback type="invalid">Invalid College Name </Form.Control.Feedback>
                                                                    </div>
                                                                </Form.Group>
                                                            </Col>
                                                        </> : ""
                                                }
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Branch<em className="Required">*</em></Form.Label>
                                                        <div className="col">
                                                            <Form.Select as="select" value={branch} onChange={(e) => setBranch(e.target.value)} required >
                                                                <option value={""}>Select</option>
                                                                {branchlists.map(item => (
                                                                    <option key={item._id} value={item._id}>{item.Name}</option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid"> Branch is required</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label> Year <em className="Required">*</em></Form.Label>
                                                        <div className="col">
                                                            <Form.Select as="select" value={year} onChange={(e) => setYear(e.target.value)} required >
                                                                <option value={''}>Select</option>
                                                                {yearlist.map(item => (
                                                                    <option key={item._id} value={item._id}>{item.Name}</option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid"> Year is required</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Semester<em className="Required">*</em></Form.Label>
                                                        <div className="col">
                                                            <Form.Select as="select" value={semester} onChange={(e) => setSemester(e.target.value)} required >
                                                                <option value={""}>Select</option>
                                                                {semesterlist.map(item => (
                                                                    <option key={item._id} value={item._id}>{item.Name}</option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid"> Semester is required</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label> Contact Number <em className="Required">*</em></Form.Label>
                                                        <div className='col'>
                                                            <Form.Control name="email" type="numeric" minLength={10} maxLength={10} id="ContactNumber" value={ContactNumber} onChange={(e) => handlphnumberchange(e.target.value)} placeholder="Enter Contact Number" isInvalid={!!NumberError} required />
                                                            <Form.Control.Feedback type="invalid">{NumberError}</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label> Email <em className="Required">*</em></Form.Label>
                                                        <div className='col'>
                                                            <Form.Control name="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} id="email" placeholder="Enter email" required />
                                                            <Form.Control.Feedback type="invalid"> Email is required</Form.Control.Feedback>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                                {isOthersSelected ?
                                                    <>
                                                        <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label className='d-flex justify-content-between align-items-center'>
                                                                    <span> Upload College Approval letter<em className="Required">*</em> </span>
                                                                    <span className="icon-container">
                                                                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M256 56C145.72 56 56 145.72 56 256s89.72 200 200 200 200-89.72 200-200S366.28 56 256 56zm0 82a26 26 0 1 1-26 26 26 26 0 0 1 26-26zm64 226H200v-32h44v-88h-32v-32h64v120h44z"></path>
                                                                        </svg>
                                                                        <span className="labelWarning">Permission letter to signed by HOD and Principal.</span>
                                                                    </span>
                                                                </Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control accept="application/pdf" type="file" onChange={(e) => setPDFUpload(e.target.files[0])} required />
                                                                    <Form.Control.Feedback type="invalid"> Approval Letter is required</Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                    </> : ""
                                                }
                                                <Col lg={10}>
                                                    <Form.Group className="my-2">
                                                        <Form.Label> <h5>Terms & Condition<em className="Required">*</em></h5></Form.Label>
                                                        <div className='col d-flex align-items-center'>
                                                            <Form.Check name="terms" id="terms" type="checkbox" onClick={handleTermsandConditions} /> &nbsp; &nbsp;
                                                            <h6 className="ms-2 mt-4 terms_condition">I hereby agree & undertake to abide by the terms & conditions of participation as decided by Grok Learning and the industry partner.</h6>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row className=''>
                                                <Col xs={4}>
                                                    {/* <Button variant="danger" size="sm" type="submit" onClick={() => clear()}> Clear </Button> */}
                                                </Col>
                                                <Col>
                                                    <div className="d-flex gap justify-content-end">
                                                        <Button variant="primary" type="submit" size="sm" disabled={!isConditionsAccepted}> Register </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>
                                </Modal.Body>
                            </Modal>
                        </div>
                    </div>
                </Container>
                <Footer />
            </div>
        </div>
    );
};

export default BusinessChallenges;
